import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EventsHubService } from '../../../core/events-hub.service';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService, BannerNotificationsService } from '../../../xform-compat';
import { CrmAgendaService } from '../../../core/data-services/crm-agenda-service';
import { CRMAgendaItem } from '../../models/crm/CRMAgendaItem.model';
import { Domain } from '../../models/domain.model';
import { CRMAgendaSchedule } from '../../models/crm/CRMAgendaSchedule.model';
import { DomainService } from '../../../core/data-services/domain.service';

@Component({
    selector: 'rms-send-crm-agenda',
    templateUrl: './send-crm-agenda.component.html',
    styleUrls: ['./send-crm-agenda.component.scss'],
    standalone: false
})
export class SendCrmAgendaComponent implements OnInit,  OnDestroy {

  @ViewChild('sendCrmAgenda', { static: true }) modal: ElementRef;
  private modalReference: NgbModalRef;
  private modalSubscription: Subscription;
  private agendaItems: Array<CRMAgendaItem> = [];
  private userDomains: Array<Domain> = [];
  private agendaSchedule: Array<CRMAgendaSchedule> = [];
  private allDomains: Array<Domain> = [];
  public domainTotals: Record<string, number>;
  public selectedDomainId: number;

  constructor (
    private crmAgendaService: CrmAgendaService,
    private domainService: DomainService,
    private eventsHubService: EventsHubService,
    private modalService: NgbModal,
    private spinnerService: SpinnerService,
    private bannerNotificationService: BannerNotificationsService,
  ) { }


  ngOnDestroy(): void {
    this.modalSubscription.unsubscribe();
  }

  ngOnInit() {
    this.getAllDomains();
    this.getAgendaSchedule();
    this.modalSubscription = this.eventsHubService.onCrmItemAgendaSent$.subscribe((data = {}) => {
      const { agendaItems = [], userDomains = [], onSend = () => {}, } = data;
      this.userDomains = userDomains.sort((a, b) => a.name > b.name ? 1 : -1);
      this.agendaItems = agendaItems.sort((a, b) => this.getDomainById(a.domainId) > this.getDomainById(b.domainId) ? 1 : -1);
      this.domainTotals = this.agendaItems.reduce((acc, x) => {
        const domainName = this.getDomainById(x.domainId);
        acc[domainName]  = (domainName in acc) ?  acc[domainName] + 1 : 1;
        return acc;
      }, {});

      this.modalReference = this.modalService.open(this.modal, { size: 'lg', centered: true });

      this.modalReference.result.then(result => {
        if (this.selectedDomainId && result) {
          this.spinnerService.start();
          this.crmAgendaService.sendAgenda(result).subscribe((resp) => {
            this.spinnerService.stop();
            onSend(resp);
            this.bannerNotificationService.success(`SONAR Agenda Sent`);
          }, err => {
            this.bannerNotificationService.error(err);
            this.spinnerService.stop();
          });
        }
      });
    });
  }

  public submit() {
    this.modalReference.close(this.selectedDomainId);
  }

  public close() {
    this.modalReference.close();
  }

  public formatAgenda(): Array<string> {
    return this.agendaSchedule && this.agendaSchedule.length > 0 ?
       this.agendaSchedule.map(s =>
        `${this.formatDomainName(s)}: ${this.formatScheduledDay(s)} @ ${this.formatScheduledTime(s)}`) :
        ['No Scheduled Agendas'];
  }

  private getDomainById(id: number): string {
    const domain = this.allDomains.find(a => a.id === id);
    return domain ? domain.name : null;
  }

  private formatDomainName(schedule: CRMAgendaSchedule): string {
    return schedule && this.allDomains.length > 0 ? this.allDomains.find(a => a.id === schedule.domainId).shortName : '';
  }

  private formatScheduledDay(schedule: CRMAgendaSchedule): string {
    return schedule && schedule.scheduledDay ? `${schedule.scheduledDay.charAt(0) + schedule.scheduledDay.slice(1).toLowerCase()}s` : '';
  }

  private formatScheduledTime(schedule: CRMAgendaSchedule): string {
    if (schedule && schedule.scheduledTime) {
      const [hours, mins, ...secs] = schedule.scheduledTime.split(':');
      return `${+hours > 12 ? +hours - 12 : hours}:${mins} ${+hours >= 12 ? 'PM' : 'AM'}`;
    }
    return '';
  }

  private getAgendaSchedule() {
    this.crmAgendaService.getAgendaSchedule().subscribe(data => this.agendaSchedule = data);
  }

  private getAllDomains() {
    this.domainService.domains.subscribe(data => this.allDomains = data.records.sort((a, b) => a.name > b.name ? 1 : -1 ) );
  }
}
